import React, { useEffect } from 'react';
import { clsx } from 'clsx';

export type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
};

export default function Modal({ open, onClose, children, className, overlayClassName }: ModalProps) {
  useEffect(() => {
    if (!open) return;

    const prevBody = document.body.style.overflow;
    const prevHtml = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = prevBody;
      document.documentElement.style.overflow = prevHtml;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      aria-hidden={!open}
      className={clsx(
        'fixed inset-0 z-[100] transition-opacity duration-300 overflow-x-hidden',
        'pointer-events-auto opacity-100'
      )}
    >
      {/* Overlay */}
      <div
        className={clsx(
          'absolute inset-0 bg-[#0a1628]/80 backdrop-blur-md',
          overlayClassName
        )}
        onClick={onClose}
      />

      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#f97316]/15 blur-[120px] rounded-full" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#ec4899]/12 blur-[100px] rounded-full" />
      </div>

      <div
        role="dialog"
        aria-modal="true"
        className={clsx(
          'absolute inset-0 flex items-center justify-center px-4 py-8 h-[100dvh]',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
